const prefix = 'AUTH_';

export const AUTH_USER_LOGIN_REQUEST = `${prefix}USER_LOGIN_REQUEST`;
export const AUTH_USER_LOGIN_RECEIVE = `${prefix}USER_LOGIN_RECEIVE`;
export const AUTH_USER_LOGIN_ERROR = `${prefix}USER_LOGIN_ERROR`;

export const AUTH_USER_DRIVER_REQUEST = `${prefix}USER_DRIVER_REQUEST`;
export const AUTH_USER_DRIVER_RECEIVE = `${prefix}USER_DRIVER_RECEIVE`;
export const AUTH_USER_DRIVER_ERROR = `${prefix}USER_DRIVER_ERROR`;

export const AUTH_USER_LOGOUT_REQUEST = `${prefix}USER_LOGOUT_REQUEST`;
export const AUTH_USER_LOGOUT_RECEIVE = `${prefix}USER_LOGOUT_RECEIVE`;
export const AUTH_USER_LOGOUT_ERROR = `${prefix}USER_LOGOUT_ERROR`;
export const AUTH_USER_CLEAR_LOGIN_ERROR = `${prefix}CLEAR_LOGIN_ERROR`;

export const AUTH_USER_SET_ROLES = `${prefix}USER_SET_ROLES`;
export const REHYDRATE = 'persist/REHYDRATE';
